import { RootState } from '../store'
export const selectIncidents = (state: RootState) => state.incident.incidents
export const selectLoading = (state: RootState) => state.incident.loading
export const selectError = (state: RootState) => state.incident.error
export const selectRelatedIncidents = (state: RootState) =>
  state.incident.relatedIncidents
export const selectSecurityControlsLoading = (state: RootState) =>
  state.incident.loading

export const selectSecurityControlsError = (state: RootState) =>
  state.incident.error
